import { COMMAND_PALETTE_REGISTRY_IDS } from '@atlassian/jira-command-palette-registry/src/common/constants/registry/index.tsx';
import { useRegisterCommands } from '@atlassian/jira-command-palette-registry/src/controllers/use-register-commands/index.tsx';
import { useIssueNavigatorLink } from '../../controllers/use-issue-navigator-link/index.tsx';
import { useCopyPageUrlCommand } from './use-copy-page-url/index.tsx';
import { useNavigationCommands } from './use-navigation-commands/index.tsx';

export const useRegisterInitialCommands = () => {
	const copyCommand = useCopyPageUrlCommand();
	const navigationCommands = useNavigationCommands();
	const { issueNavigatorLink } = useIssueNavigatorLink();

	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.COPY_URL, [copyCommand]);
	useRegisterCommands(COMMAND_PALETTE_REGISTRY_IDS.NAVIGATION_COMMANDS, navigationCommands, [
		issueNavigatorLink,
	]);
};
